import {
  motion,
  useReducedMotion,
  useScroll,
  useSpring,
  useTransform,
} from 'framer-motion';
import { useRef } from 'react';

const wrap = (min: number, max: number, v: number) => {
  const range = max - min;
  return ((((v - min) % range) + range) % range) + min;
};

const ParallaxText = () => {
  const ref = useRef(null);
  const prefersReducedMotion = useReducedMotion();
  const { scrollY } = useScroll({
    target: ref,
    offset: ['start end', 'end start']
  });

  // Versione “18 gennaio”: movimento SOLO in funzione dello scroll (se ti fermi, si ferma)
  // + smoothing per un feeling più premium.
  const smoothScrollY = useSpring(scrollY, { stiffness: 80, damping: 22, mass: 0.35 });

  // Tuning: percentuali per px scrollati (più alto = più veloce).
  const line1Factor = 0.02;
  const line2Factor = 0.018;

  const x1 = useTransform(smoothScrollY, (v) => `${wrap(-50, 0, -(v * line1Factor))}%`);
  // Offset iniziale per “sfalsare” la seconda riga come prima.
  const x2 = useTransform(smoothScrollY, (v) => `${wrap(-50, 0, (v * line2Factor) - 25)}%`);

  const line1 = 'Strategia • Crescita • Risultati • ROI •';
  const line2 = 'Digital Marketing • SEO • Ads • Analytics •';
  const repeats = new Array(8).fill(null);

  return (
    <section ref={ref} aria-hidden="true" className="py-12 md:py-16 overflow-hidden">
      <motion.div style={{ x: prefersReducedMotion ? '0%' : x1 }} className="mb-4 will-change-transform">
        <div className="flex whitespace-nowrap">
          {repeats.map((_, i) => (
            <p key={i} className="parallax-text text-foreground pr-10" data-text={line1} />
          ))}
        </div>
      </motion.div>

      <motion.div style={{ x: prefersReducedMotion ? '0%' : x2 }} className="will-change-transform">
        <div className="flex whitespace-nowrap">
          {repeats.map((_, i) => (
            <p key={i} className="parallax-text text-gold/10 pr-10" data-text={line2} />
          ))}
        </div>
      </motion.div>
    </section>
  );
};

export default ParallaxText;
